export const transform = ({
                              id,
                              person_id,
                              display,
                              unit,
                              job,
                              name,
                              remarks,
                              readiness_level,
                              birthday,
                              isAus
                          }) => (
    {
        id: id,
        person_id:person_id,
        display: display,
        name: name,
        unit: {
            id: unit.id, name: unit.name
        },
        job:
            {id: job.id, name: job.name},
        remarks: remarks,
        readiness_level: {id: readiness_level.id, name: readiness_level.name},
        birthday: birthday,
        isAus
    }
);
